import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-5 pb-5 px-3 relative overflow-hidden border-b-2 border-brand-accent" data-id="element-92">
      {/* Soft contrast light behind content */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[90%] h-[60%] bg-brand-accent/15 blur-[120px] rounded-full pointer-events-none" data-id="element-93"></div>

      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-94">
        <div className="inline-block bg-brand-accent/20 text-brand-accent font-black px-3 py-1 rounded-full mb-3 text-[10px] md:text-xs tracking-widest uppercase border border-brand-accent/50" data-id="element-95">
          ⚠️ ATENCIÓN HERREROS Y TALLERES
        </div>

        <h1 className="text-xl md:text-3xl lg:text-4xl font-black mb-3 leading-tight text-shadow-lg uppercase tracking-tight" data-id="element-96">
          LOS TRABAJOS MODERNOS SON LOS QUE{' '}
          <span className="text-brand-accent neon-glow" data-id="element-97">MÁS DINERO</span> ESTÁN
          DEJANDO EN HERRERÍA
        </h1>

        <h2 className="text-xs md:text-lg font-bold mb-5 text-gray-300 max-w-2xl leading-relaxed" data-id="element-98">
          Accedé al sistema completo con planos premium para fabricar puertas
          modernas, pérgolas, escaleras y portones que hoy todos quieren.
        </h2>

        <a href="#compra" onClick={scrollToCompra} className="w-full max-w-[280px] md:max-w-md mx-auto mb-5 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 block relative" data-id="element-99">
          {/* Soft glow halo behind image */}
          <div className="absolute inset-0 bg-gradient-radial from-brand-accent/30 via-brand-accent/10 to-transparent blur-3xl scale-110" data-id="element-100"></div>
          <img src="https://cdn.magicpatterns.com/uploads/tHpcoB97KkXuCQxLVk4yqG/my-project-page-1.png" alt="Mega Pack Herrería Moderna" className="w-full h-auto drop-shadow-2xl relative z-10" data-id="element-101" />
        </a>

        <p className="text-[11px] md:text-base mb-5 font-bold text-brand-neon max-w-xl mx-auto leading-relaxed bg-brand-accent/10 py-2 px-4 rounded-lg border border-brand-accent/30" data-id="element-102">
          Diseños modernos, medidas listas para usar y trabajos premium que te
          ayudan a diferenciarte y cobrar mejor.
        </p>

        <div className="w-full max-w-sm mx-auto mb-3" data-id="element-103">
          <Button onClick={scrollToCompra} className="py-3 md:py-4 text-sm md:text-lg" data-id="element-104">
            👉 QUIERO EL MEGA PACK AHORA
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5 text-[9px] md:text-xs text-gray-400 font-bold mt-2" data-id="element-105">
          <div className="flex items-center" data-id="element-106">
            <ShieldCheck className="w-3 h-3 mr-1 text-brand-accent" data-id="element-107" />
            <span data-id="element-108">Garantía 7 días</span>
          </div>
          <div className="flex items-center" data-id="element-109">
            <Lock className="w-3 h-3 mr-1 text-brand-accent" data-id="element-110" />
            <span data-id="element-111">Pago Seguro</span>
          </div>
          <div className="flex items-center" data-id="element-112">
            <CreditCard className="w-3 h-3 mr-1 text-brand-accent" data-id="element-113" />
            <span data-id="element-114">Acceso Inmediato</span>
          </div>
        </div>
      </div>
    </section>;
}